<template>
  	<div id="app">
    	<router-view />
  	</div>
</template>

<script>
export default {
  	name: "App"
}
</script> 
<style>
* {
	font-family: MicrosoftYaHei;
	padding: 0;
	margin: 0;
	box-sizing: border-box;
	-moz-box-sizing: border-box;
	-o-box-sizing: border-box;
}
/*.el-upload {
  	border: 1px dashed #d9d9d9;
  	border-radius: 6px;
  	cursor: pointer;
  	position: relative;
  	overflow: hidden;
}
.el-upload:hover {
  	border-color: #409eff;
}*/
.avatar-uploader {
    padding-top: 20px;
}
.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 150px;
    height: 150px;
    display:flex;
    align-items:center;
    justify-content: center;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px!important;
    text-align: center;
    /*padding-top:40px;*/
}
.el-upload:hover {
    border-color: #409eff;
}
.avatar {
    max-width: 100%;
}
/* 搜索条件 */
.searchBtn {
  	border-bottom: solid 1px gainsboro;
  	padding-bottom: 10px;
}
/*栏目标题*/
.breadcrumb{
	margin: 0 0 20px
}
.addBtn{
  margin-top: 15px
}
</style>



// WEBPACK FOOTER //
// src/App.vue